export const FoxitPlugIns = {
  "Modal": {
    "Title": "About Foxit Plug-ins"
  },
  "Tab": {
    "MyPlugins": "My plug-ins",
    "PluginStore": "Plugin store"
  },
  "Header": {
    "Suggested": "Suggested for you"
  },
  "Sider": {
    "Category": "Category",
    "All": "All"
  },
  "Content": {
    "Install": "Install",
    "More": "More"
  },
  "Remove": "Remove",
  "NoRemoval": "Not removable",
  "UploadBtn": "Upload",
  "CancelBtn": "Cancel",
  "BrowseBtn": "Browse",
  "BackBtn": "Back",
  "Description": "Description",
  "Legal": "Legal",
  "UploadMyAddIn": "Upload my add-in",
  "CreatedTime": "Created time",
  "UpdatedTime": "Updated time",
  "Name": "Name",
  "OnOff": "Turn on/off",
  "Error": {
    "Installed": "The plugin has already been installed.",
    "NoManifest": "Please select a manifest.json file",
    "PluginLoadFailed": "Failed to load the plugin.",
    "PluginUnloadFailed": "Failed to upload the plugin."
  },
  "Success": {
    "Installed": "The plugin is installed successfully.",
    "PluginLoadSuccess": "The plugin is loaded successfully.",
    "RemoveSuccess": "The plugin is removed successfully."
  },
  "Status": {
    "PluginLoadFailed": "This plug-in failed to be loaded",
    "CertificatedPlugin": "Certificated plug-in",
    "NotCertificated": "This plug-in has not been certified, it might cause damage to your computer"
  },
  "UploadTitle": "This feature is suitable for developers to test their add-ons.",
  "SelectPluginTitle": "Select plug-in list: ",
  "Button": {
    "Reload": "Reload"
  },
  "NoData": "No Data"
}